import {
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import {
  BusinessCenter,
  ChromeReaderMode,
  Dashboard,
  DynamicFeed,
  LockOpenOutlined,
  People,
  SdCardOutlined
} from '@material-ui/icons'
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'

import { FaBed, FaLaptopMedical, FaTasks, FaTools } from 'react-icons/fa'
import { GoPackage } from 'react-icons/go'
import { useHistory } from 'react-router-dom'
import UBox from 'src/components/ui/Ubox'
import config from 'src/config'
import { SynRoutes } from 'src/core/consts/synRoutes'
import useAtividade from 'src/hooks/useAtividade'
import useAuth from 'src/hooks/useAuth'
import { gerarAuthCode } from 'src/api/auth/index'
import { SynPerfis } from 'src/core/consts/synPerfis'

function menuLateral(props) {
  const history = useHistory()
  const { user, perfilAtual } = useAuth()
  const { obterQtdePendente } = useAtividade()
  return (
    <List>
      {/* <ListItem button>
        <ListItemIcon>
          <Assignment />
        </ListItemIcon>
        <ListItemText primary="Orçamentos" />
      </ListItem> */}

      {perfilAtual === SynPerfis.SUPER_ADMIN && (
        <ListItem
          button
          onClick={() => history.push(SynRoutes.listagemUsuariosSyn)}
          id="submenus-equipe-syn"
        >
          <ListItemIcon>
            <People />
          </ListItemIcon>
          <ListItemText primary="Gerenciar equipe Syn" />
        </ListItem>
      )}

      {perfilAtual === SynPerfis.SUPER_ADMIN && (
        <ListItem
          button
          onClick={() => history.push(SynRoutes.painelRegularizacaoBacen)}
          id="submenus-regularizacao-bacen"
        >
          <ListItemIcon>
            <AssignmentOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Regularização BACEN" />
        </ListItem>
      )}

      {perfilAtual === SynPerfis.SUPER_ADMIN && (
        <ListItem
          button
          onClick={async () => {
            const code = await gerarAuthCode()
            console.log(code)
            window.location.href = `${config.baseUrlV2}?code=${code}`
          }}
          id="submenus-atualizacoes"
        >
          <ListItemIcon>
            <DynamicFeed />
          </ListItemIcon>
          <ListItemText primary="Configurar hospitais" />
        </ListItem>
      )}

      <UBox>
        <ListItem
          button
          onClick={() => history.push(SynRoutes.listagemUsuarios)}
          id="submenus-usuarios"
        >
          <ListItemIcon>
            <People />
          </ListItemIcon>
          <ListItemText primary="Usuários" />
        </ListItem>
      </UBox>

      {!!user.verDashboard && (
        <ListItem
          button
          onClick={() => history.push(SynRoutes.dashboard)}
          id="submenus-dashboard"
        >
          <ListItemIcon>
            <Dashboard />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
      )}

      <ListItem
        button
        onClick={() => history.push(SynRoutes.acomodacoes)}
        id="submenus-acomodacoes"
      >
        <ListItemIcon>
          <FaBed />
        </ListItemIcon>
        <ListItemText primary="Acomodações" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.equipamentos)}
        id="submenus-equipamentos"
      >
        <ListItemIcon>
          <FaLaptopMedical />
        </ListItemIcon>
        <ListItemText primary="Equipamentos" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemMedicos)}
        id="submenus-medicos"
      >
        <ListItemIcon>
          <People />
        </ListItemIcon>
        <ListItemText primary="Médicos" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemPacotesOperacional)}
        id="submenus-pacotes"
      >
        <ListItemIcon style={{ fontSize: '1.4rem' }}>
          <GoPackage />
        </ListItemIcon>
        <ListItemText primary="Pacotes" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemOrcamentosOperacional)}
        id="submenus-solicitacoes"
      >
        <ListItemIcon>
          <AssignmentOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Solicitações" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.tarefas)}
        id="submenus-atividades"
      >
        <ListItemIcon style={{ fontSize: '1.3rem' }}>
          {/* <FcTodoList /> */}
          <FaTasks />
        </ListItemIcon>
        <ListItemText
          primary={
            <UBox>
              Atividades{' '}
              {obterQtdePendente() > 0 && (
                <Chip
                  variant="default"
                  color="secondary"
                  size="small"
                  label={obterQtdePendente()}
                />
              )}
            </UBox>
          }
        />
      </ListItem>
      {/* <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemFinanciamentos)}
        id="submenus-financiamentos"
      >
        <ListItemIcon>
          <ChromeReaderMode />
        </ListItemIcon>
        <ListItemText primary="Financiamentos" />
      </ListItem> */}
      <ListItem
        button
        onClick={() => history.push(SynRoutes.listagemParceirosOperacional)}
        id="submenus-parceiros"
      >
        <ListItemIcon>
          <BusinessCenter />
        </ListItemIcon>
        <ListItemText primary="Parceiros" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.historicoAtualizacoes)}
        id="submenus-atualizacoes"
      >
        <ListItemIcon>
          <DynamicFeed />
        </ListItemIcon>
        <ListItemText primary="Atualizações" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.resetSenha)}
        id="submenus-resetar-senha"
      >
        <ListItemIcon>
          <LockOpenOutlined />
        </ListItemIcon>
        <ListItemText primary="Resetar senha" />
      </ListItem>

      <ListItem
        button
        onClick={() => history.push(SynRoutes.termos)}
        id="submenus-termos"
      >
        <ListItemIcon>
          <SdCardOutlined />
        </ListItemIcon>
        <ListItemText primary="Termos" />
      </ListItem>

      <ListItem
        button
        onClick={() => window.open('https://syndesk.synsaude.com.br/', '_blank', 'noopener,noreferrer')}
        id="submenus-syndesk"
      >
        <ListItemIcon>
          <ChromeReaderMode />
        </ListItemIcon>
        <ListItemText primary="Syndesk" />
      </ListItem>
      {/* <ListItem
        button
        onClick={() => history.push(SynRoutes.formAddUserOperacional)}
      >
        <ListItemIcon>
          <Add />
        </ListItemIcon>
        <ListItemText primary="Novo usuário" />
      </ListItem> */}

      {/* <ListItem button>
        <ListItemIcon>
          <AirlineSeatFlat />
        </ListItemIcon>
        <ListItemText primary="Pacientes" />
      </ListItem>

      <ListItem button>
        <ListItemIcon>
          <Apartment />
        </ListItemIcon>
        <ListItemText primary="Locais de atendimento" />
      </ListItem> */}
    </List>
  )
}

export default menuLateral
